const EXPERIENCE_JOB_SET = 'EXPERIENCE_JOB_SET';
const EXPERIENCE_JOB_SET_VALIDATION_MESSAGE = 'EXPERIENCE_JOB_SET_VALIDATION_MESSAGE';
const EXPERIENCE_JOB_SET_VISUALIZATION = 'EXPERIENCE_JOB_SET_VISUALIZATION';
const EXPERIENCE_JOB_SET_API_ERROR = 'EXPERIENCE_JOB_SET_API_ERROR';
const EXPERIENCE_JOB_SET_FOCUS = 'EXPERIENCE_JOB_SET_FOCUS';
const EXPERIENCE_JOB_BLURRED = 'EXPERIENCE_JOB_BLURRED';
const EXPERIENCE_JOB_FOCUSED = 'EXPERIENCE_JOB_FOCUSED';
const EXPERIENCE_JOB_CHANGE = 'EXPERIENCE_JOB_CHANGE';
const EXPERIENCE_JOB_RESET_SUGGESTIONS = 'EXPERIENCE_JOB_RESET_SUGGESTIONS';
const EXPERIENCE_JOB_GET_SUGGESTIONS = 'EXPERIENCE_JOB_GET_SUGGESTIONS';
const EXPERIENCE_JOB_SET_SUGGESTIONS = 'EXPERIENCE_JOB_SET_SUGGESTIONS';
const EXPERIENCE_JOB_SUGGESTIONS_ERROR = 'EXPERIENCE_JOB_SUGGESTIONS_ERROR';

const experienceJobSet = (value) => ({
  type: EXPERIENCE_JOB_SET,
  payload: {
    value
  }
});

const experienceJobSetValidationMessage = (validationMessage) => ({
  type: EXPERIENCE_JOB_SET_VALIDATION_MESSAGE,
  payload: {
    validationMessage
  }
});

const experienceJobSetVisualization = (markedAsWrong) => ({
  type: EXPERIENCE_JOB_SET_VISUALIZATION,
  payload: {
    markedAsWrong
  }
});

const experienceJobSetApiError = (payload) => ({
  type: EXPERIENCE_JOB_SET_VISUALIZATION,
  payload
});

const experienceJobSetFocus = (focus) => ({
  type: EXPERIENCE_JOB_SET_FOCUS,
  payload: {
    focus
  }
});

const experienceJobBlur = (markedAsWrong, validationMessage) => ({
  type: EXPERIENCE_JOB_BLURRED,
  payload: {
    markedAsWrong, validationMessage
  }
});

const experienceJobFocus = () => ({
  type: EXPERIENCE_JOB_FOCUSED
});

const experienceJobChange = (payload) => ({
  type: EXPERIENCE_JOB_CHANGE,
  payload
});

const experienceJobSuggestionsReset = () => ({
  type: EXPERIENCE_JOB_RESET_SUGGESTIONS
});

const experienceJobSuggestionsGet = (query) => ({
  type: EXPERIENCE_JOB_GET_SUGGESTIONS,
  payload: {
    query
  }
});

const experienceJobSuggestionsSet = (suggestions) => ({
  type: EXPERIENCE_JOB_SET_SUGGESTIONS,
  payload: {
    suggestions
  }
});

const experienceJobSuggestionsError = () => ({
  type: EXPERIENCE_JOB_SUGGESTIONS_ERROR
});

export {
  experienceJobSetValidationMessage,
  experienceJobSetVisualization,
  experienceJobFocus,
  experienceJobSetFocus,
  experienceJobSetApiError,
  experienceJobBlur,
  experienceJobSet,
  experienceJobChange,
  experienceJobSuggestionsReset,
  experienceJobSuggestionsGet,
  experienceJobSuggestionsSet,
  experienceJobSuggestionsError,
  EXPERIENCE_JOB_SUGGESTIONS_ERROR,
  EXPERIENCE_JOB_SET_SUGGESTIONS,
  EXPERIENCE_JOB_RESET_SUGGESTIONS,
  EXPERIENCE_JOB_CHANGE,
  EXPERIENCE_JOB_FOCUSED,
  EXPERIENCE_JOB_BLURRED,
  EXPERIENCE_JOB_SET_FOCUS,
  EXPERIENCE_JOB_SET_API_ERROR,
  EXPERIENCE_JOB_SET_VALIDATION_MESSAGE,
  EXPERIENCE_JOB_SET,
  EXPERIENCE_JOB_SET_VISUALIZATION,
  EXPERIENCE_JOB_GET_SUGGESTIONS
};

